import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';

@Component({
  selector: 'app-dialog-ok',
  templateUrl: './dialog-ok.component.html',
  styleUrls: ['./dialog-ok.component.scss']
})
export class DialogOkComponent implements OnInit {
	msg: any;

	constructor(
		public dialogRef: MatDialogRef<DialogOkComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.msg = data.msg;
	}

	ngOnInit() {

	}

	ok(){
		this.dialogRef.close();
	}
}
